(async () => {
    const {
        updateURLParams: n,
        historyPush: a,
        parseHTML: i
    } = await import(window.theme.modules.utils);
    var t = await import(window.theme.modules.baseComponent);
    customElements.define("product-form", class extends t.default {
        elements = {
            form: "form",
            addButton: "[data-add-button]",
            buyButton: "[data-buy-button]",
            content: "[data-content]",
            input: "[data-variant-id-input]",
            sellingPlanInput: 'input[name="selling_plan"]'
        };
        async render() {
            if (this._enableInput(), this.cartSection = document.querySelector("main-cart"), this.isProductPage = "product" === this.getAttribute("page-type"), this.listenTo("variantChange", (t, e) => {
                    this._rerender(e), e.variant && this._rerenderVariantInput(e)
                }), this.on("cartChange", (t, e) => {
                    this._updateQtyStatus(e.variantId)
                }, !1), this.hasAttribute("cart-popup") && this.$form.addEventListener("submit", this._handleSubmit.bind(this)), this.$sellingPlanInput && this.hasAttribute("selling-plan-enable")) {
                this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
                const {
                    observeInputValueChange: t
                } = await import(window.theme.modules.sellingPlanUtil);
                t(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this))
            }
        }
        _handleSellingPlanChange(t) {
            var e;
            t !== this.currentSellingPlanId && (this.currentSellingPlanId = t, {
                queryURL: e,
                currentURL: t
            } = n({
                selling_plan: this.currentSellingPlanId,
                variant: this.getAttribute("current-variant")
            }, this.sectionId), this.isProductPage && a(t), this._fetchPageWithVariant(e, t => {
                this.forwardEvent("sellingPlanChange", {
                    html: t
                })
            }))
        }
        _enableInput() {
            this.$input.disabled = !1
        }
        _fetchPageWithVariant(t, e) {
            return fetch(t).then(t => t.text()).then(t => {
                t = i(t);
                e(t)
            })
        }
        _rerender(t) {
            const e = t.html.querySelector("[data-content]");
            this.$content.replaceChildren(...e.cloneNode(!0).childNodes), this._rerenderPaymentButton()
        }
        _rerenderVariantInput(t) {
            this.setAttribute("current-variant", `${t.variant.id}`);
            t = t.html.querySelector(this.elements.input).value;
            this.$input.value = t
        }
        _rerenderPaymentButton() {
            window.Shopify?.PaymentButton?.init && window.Shopify.PaymentButton.init()
        }
        _handleSubmit(t) {
            t.preventDefault(), this.formData = new FormData(t.target), this._addToCartRequest()
        }
        _addToCartRequest() {
            this._setLoading(!0), fetch(`${window.routes.cart_add_url}.js`, {
                method: "POST",
                headers: {
                    Accept: "application/javascript"
                },
                body: this.formData
            }).then(t => t.json()).then(() => {

			$.magnificPopup.close();


                this.trigger("updateCart", {
                    callback: () => {
                        this._setLoading(!1), this._updateQtyStatus(this.formData.get("id")), this.cartSection ? this.cartSection.update() : this.trigger("openPopup", {
                            target: "CART"
                        })
                    }
                })
            }).catch(t => {
                this._setLoading(!1), console.log(t)
            })
        }
        _updateQtyStatus(e) {
            var t = `${this.getAttribute("product-url")}?variant=${e}&section_id=${this.getAttribute("section-id")}`;
            this._fetchPageWithVariant(t, t => {
                this.trigger("qtyStatusUpdate", {
                    html: t,
                    variantId: e
                }), this._rerender({
                    html: t
                })
            })
        }
        _setLoading(t) {
            t ? this.$addButton.setAttribute("loading", "") : this.$addButton.removeAttribute("loading")
        }
    })
})();